import { render, staticRenderFns } from "./HistoryV2.vue?vue&type=template&id=53d3300d&scoped=true"
import script from "./HistoryV2.vue?vue&type=script&lang=js"
export * from "./HistoryV2.vue?vue&type=script&lang=js"
import style0 from "./HistoryV2.vue?vue&type=style&index=0&id=53d3300d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3300d",
  null
  
)

export default component.exports